/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import withCongress, { ComponentProps } from '../../providers/Congress/withCongress'
import Content from '../../components/Layout/Content'
import { Route, RouteComponentProps, Switch } from 'react-router-dom'
import FormRouter from '../../routers/FormRouter'
import { getSteps } from '../../helpers/routes'
import withWizardProps, { WizardProps } from '../../wrappers/withWizardParams'
import { flowRight } from 'lodash'
import { getNextWizardPath } from '../../helpers/wizard'
import Timer from '../../components/Timer/Timer'
import Steps from '../../components/Wizard/Steps/Steps'
import ReservationProvider from '../../providers/Reservation/reservationProvider'

interface Props extends ComponentProps, RouteComponentProps, WizardProps {
}

interface State {
}

class Wizard extends React.Component<Props, State> {
  state = {
    currentStep: '',
  }

  componentWillMount () {
    this.setCurrentStep()
  }

  componentDidUpdate (prevProps: Readonly<Props>) {
    const { wizard: newWizard } = this.props
    const { wizard: oldWizard } = prevProps

    if (newWizard.step !== oldWizard.step) {
      this.setCurrentStep()
    }
  }

  setCurrentStep = () => {
    const { congress, history, wizard } = this.props

    const steps = getSteps(congress.Slug)

    if (steps.map(i => i.toLowerCase()).indexOf(wizard.step) > -1) {
      this.setState({ currentStep: wizard.step })
    } else {
      const path = getNextWizardPath(wizard.token, congress.Slug)
      this.setState({ currentStep: steps[0] })
      history.replace(path)
    }
  }

  render () {
    const { congress } = this.props
    const { currentStep } = this.state

    return (
      <ReservationProvider>
        <Content>
          {currentStep !== 'success' && <Timer color={congress.PrimaryColor}/>}

          <Steps currentStep={currentStep}/>

          <Switch>
            <Route path="/:congressSlug/wizard/:token/:step" component={FormRouter}/>
          </Switch>
        </Content>
      </ReservationProvider>
    )
  }
}

export default flowRight([withCongress, withWizardProps])(Wizard)
